import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/ServiceDetailPage.css';

const SolucionesIntegralesPage = () => {
  const subServices = [
    {
      title: 'Facility Management',
      description: 'Gestión integral de todas las instalaciones y servicios de su empresa.',
      features: [
        'Administración de facilities',
        'Mantenimiento integral',
        'Servicios de limpieza',
        'Gestión de proveedores',
        'Optimización de costos'
      ]
    },
    {
      title: 'Outsourcing Integral',
      description: 'Tercerización completa de servicios para optimizar su operación.',
      features: [
        'Servicios múltiples integrados',
        'Un solo punto de contacto',
        'Gestión unificada',
        'Reportes consolidados',
        'Mayor control y eficiencia'
      ]
    },
    {
      title: 'Soluciones Personalizadas',
      description: 'Diseño de servicios a medida según necesidades específicas de su empresa.',
      features: [
        'Análisis de necesidades',
        'Diseño de soluciones',
        'Implementación gradual',
        'Seguimiento continuo',
        'Ajustes y mejoras'
      ]
    },
    {
      title: 'Gestión de Proyectos',
      description: 'Administración profesional de proyectos complejos y multidisciplinarios.',
      features: [
        'Planificación estratégica',
        'Coordinación de equipos',
        'Control de avances',
        'Gestión de recursos',
        'Entrega en tiempo y forma'
      ]
    },
    {
      title: 'Consultoría Operativa',
      description: 'Asesoría para optimizar procesos y mejorar la eficiencia operativa.',
      features: [
        'Diagnóstico operativo',
        'Identificación de mejoras',
        'Diseño de procesos',
        'Implementación de cambios',
        'Medición de resultados'
      ]
    },
    {
      title: 'Gestión de Calidad',
      description: 'Implementación de sistemas de gestión de calidad y mejora continua.',
      features: [
        'Sistemas de gestión ISO',
        'Auditorías de calidad',
        'Mejora continua',
        'Capacitación en calidad',
        'Certificaciones'
      ]
    }
  ];

  return (
    <div className="service-detail-page">
      <section className="service-hero">
        <div className="service-hero-content">
          <h1>Soluciones Integrales</h1>
          <p>Servicios combinados para resultados excepcionales</p>
        </div>
      </section>

      <section className="service-intro">
        <div className="container">
          <div className="intro-content">
            <div className="intro-text">
              <h2>Su Socio Estratégico de Confianza</h2>
              <p>
                Nuestras soluciones integrales combinan múltiples servicios para ofrecer una gestión 
                completa y eficiente de las necesidades de su empresa. Con un enfoque holístico, 
                simplificamos procesos y optimizamos resultados.
              </p>
              <p>
                Al integrar diferentes áreas de servicio bajo una sola administración, garantizamos 
                coherencia, eficiencia y resultados superiores para su organización.
              </p>
            </div>
            <div className="intro-image">
              <img 
                src="/images/soluciones-principal.jpg" 
                alt="Soluciones Integrales"
                onError={(e) => {
                  e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 400"%3E%3Crect fill="%230D3B66" width="500" height="400"/%3E%3Ctext x="50%25" y="50%25" text-anchor="middle" dy=".3em" fill="white" font-size="80"%3E✨%3C/text%3E%3C/svg%3E';
                }}
              />
            </div>
          </div>
        </div>
      </section>

      <section className="sub-services">
        <div className="container">
          <h2>Nuestras Soluciones Integrales</h2>
          <div className="sub-services-grid">
            {subServices.map((service, index) => (
              <div key={index} className="sub-service-card">
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <ul>
                  {service.features.map((feature, idx) => (
                    <li key={idx}>{feature}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="service-benefits">
        <div className="container">
          <h2>Ventajas de Nuestras Soluciones Integrales</h2>
          <div className="benefits-grid">
            <div className="benefit-item">
              <div className="benefit-icon">🎯</div>
              <h3>Un Solo Proveedor</h3>
              <p>Simplificación de la gestión</p>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">💰</div>
              <h3>Optimización de Costos</h3>
              <p>Economías de escala y eficiencia</p>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">📊</div>
              <h3>Visión Global</h3>
              <p>Control total de sus servicios</p>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">⚡</div>
              <h3>Mayor Eficiencia</h3>
              <p>Procesos coordinados y fluidos</p>
            </div>
          </div>
        </div>
      </section>

      <section className="service-cta">
        <div className="container">
          <h2>¿Busca una solución integral?</h2>
          <p>Diseñemos juntos la estrategia perfecta para su empresa</p>
          <div className="cta-buttons">
            <Link to="/contacto" className="btn-primary">Solicitar Cotización</Link>
            <Link to="/servicios" className="btn-secondary">Ver Todos los Servicios</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SolucionesIntegralesPage;
